module.exports = __webpack_public_path__ + "static/media/homeitem6.2ea1f5dc.png";